export const site = {
  name: "Vessa",
  url: "https://tryvessa.app",
  supportEmail: "support@tryvessa.app",
  lastUpdated: "July 27, 2026",
};

export const sources = [
  {
    name: "Ozempic prescribing information",
    detail: "FDA label · revision 2026 · reviewed July 24, 2026 · semaglutide injection",
    url: "https://www.accessdata.fda.gov/drugsatfda_docs/label/2026/209637s038lbl.pdf",
  },
  {
    name: "Wegovy prescribing information",
    detail: "NIH DailyMed current label · revised June 2026 · reviewed July 24, 2026 · semaglutide",
    url: "https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=ee06186f-2aa3-4990-a760-757579d8f77b",
  },
  {
    name: "Zepbound prescribing information",
    detail: "FDA label · revised February 2026 · reviewed July 24, 2026 · tirzepatide",
    url: "https://www.accessdata.fda.gov/drugsatfda_docs/label/2026/217806s042lbl.pdf",
  },
  {
    name: "Mounjaro prescribing information",
    detail: "FDA label · revised January 2026 (s041) · reviewed July 24, 2026 · tirzepatide injection",
    url: "https://www.accessdata.fda.gov/drugsatfda_docs/label/2026/215866s041lbl.pdf",
  },
  {
    name: "Trulicity prescribing information",
    detail: "FDA label · revised March 2026 · reviewed July 24, 2026 · dulaglutide injection",
    url: "https://www.accessdata.fda.gov/drugsatfda_docs/label/2026/125469s065lbl.pdf",
  },
  {
    name: "Saxenda prescribing information",
    detail: "FDA label · revision 2026 · reviewed July 24, 2026 · liraglutide injection",
    url: "https://www.accessdata.fda.gov/drugsatfda_docs/label/2026/206321s025lbl.pdf",
  },
  {
    name: "FDA: missed-dose and medication safety resources",
    detail: "FDA resource page · reviewed July 24, 2026. Use the exact, current product label and contact your prescriber or pharmacist with treatment questions.",
    url: "https://www.fda.gov/drugs/drug-safety-and-availability",
  },
];
